module.exports = __webpack_public_path__ + "static/media/model.58da01d2.glb";